import useUserStore from '@/store/modules/user';

export const createPlugins = () => {
  const DynamicWatermark = {
    content: `${useUserStore().userInfo.stuName}${useUserStore().userInfo.id}`,
    speed: 1,
    color: '#cccccc',
    opacity: 0.5,
  };

  return {
    DynamicWatermark,
  };
};

export const tcplayerTip = {
  init(tPlayerInstance) {
    const $tcplayer = $(tPlayerInstance.el_);
    const $tcplayerTip = $tcplayer.find('.tcplayer-copyright-tip');

    if (!$tcplayerTip[0]) {
      const tip = '本作品受著作权法保护，未经许可擅自转载、摘编、复制、发行、信息网络传播及商业性使用均构成侵权，将依法追究法律责任。';
      const $tcplayerTipDom = $(`<div class="tcplayer-copyright-tip"><p>${tip}</p></div>`);

      function setPos() {
        let width = $tcplayer.width();
        let height = $tcplayer.height();
        let vWidth = tPlayerInstance.videoWidth();
        let vHeight = tPlayerInstance.videoHeight();
        let tLeft;
        let tTop;
        let tWidth;

        if (width / height > vWidth / vHeight) {
          let vWidthActual = (vWidth / vHeight) * height;
          tLeft = (width - vWidthActual) / 2;
          tTop = 0;
          tWidth = vWidthActual;
        } else {
          let vHeightActual = width / (vWidth / vHeight);
          tLeft = 0;
          tTop = (height - vHeightActual) / 2;
          tWidth = width;
        }

        $tcplayerTipDom.css({
          left: tLeft,
          top: tTop,
          width: tWidth,
        });
      }

      setPos();
      $(window).resize(setPos);

      $tcplayer.append($tcplayerTipDom);
    } else {
      $tcplayerTip.fadeIn();
    }
  },
  clear(tPlayerInstance) {
    const $tcplayer = $(tPlayerInstance.el_);
    const $tcplayerTip = $tcplayer.find('.tcplayer-copyright-tip');

    setTimeout(() => {
      $tcplayerTip.fadeOut();
    }, 15 * 1000);
  },
};
